import { useState, useEffect } from 'react';
import { useProducts } from '../hooks/useProducts';
import { useCart } from '../context/CartContext';

const API = 'https://b2b-rocca-production.up.railway.app/api';

function CatalogPage() {
  const [category, setCategory] = useState('');
  const [search, setSearch] = useState('');
  const [added, setAdded] = useState({});
  const [qtyMap, setQtyMap] = useState({});
  const [categories, setCategories] = useState([{ label: 'Всі товари', value: '' }]);
  const { products, loading, error } = useProducts(category);
  const { addItem } = useCart();

  useEffect(() => {
    fetch(`${API}/categories`)
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          setCategories([
            { label: 'Всі товари', value: '' },
            ...data
              .filter(c => Number(c.product_count) > 0)
              .map(c => ({ label: c.name, value: c.slug }))
          ]);
        }
      })
      .catch(() => {});
  }, []);

  const getQty = (id) => qtyMap[id] || 1;
  const setQty = (id, val, max) => {
    let n = Math.max(1, parseInt(val, 10) || 1);
    if (max !== null && max !== undefined && n > max) n = max;
    setQtyMap(prev => ({ ...prev, [id]: n }));
  };

  const handleAdd = (product) => {
    const qty = getQty(product.id);
    addItem(product, qty);
    setAdded(prev => ({ ...prev, [product.id]: true }));
    setTimeout(() => setAdded(prev => ({ ...prev, [product.id]: false })), 1500);
  };

  const filtered = products.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    (p.brand && p.brand.toLowerCase().includes(search.toLowerCase())) ||
    (p.barcode && p.barcode.includes(search)) ||
    (p.supplier_code && p.supplier_code.includes(search))
  );

  const s = {
    page: { padding: '80px 40px 40px' },
    header: { marginBottom: 32 },
    title: { fontFamily: 'Georgia, serif', fontSize: 36, fontWeight: 700, color: '#0D1B2A', marginBottom: 8 },
    search: { width: '100%', maxWidth: 400, padding: '10px 16px', border: '1px solid #E2DECE', borderRadius: 8, fontSize: 14, outline: 'none', marginBottom: 20, boxSizing: 'border-box' },
    filters: { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 32 },
    filterBtn: (active) => ({ padding: '8px 20px', borderRadius: 20, border: '1.5px solid #E2DECE', background: active ? '#0D1B2A' : '#fff', color: active ? '#fff' : '#6B7280', fontSize: 13, fontWeight: 500, cursor: 'pointer' }),
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 20 },
    card: { background: '#fff', borderRadius: 12, border: '1px solid #E2DECE', overflow: 'hidden' },
    img: { height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 48, background: '#F8F6F0' },
    body: { padding: 16 },
    brand: { fontSize: 11, color: '#C9A84C', fontWeight: 700, letterSpacing: 1, marginBottom: 4 },
    name: { fontSize: 13, fontWeight: 600, color: '#0D1B2A', marginBottom: 6, lineHeight: 1.4, height: 54, overflow: 'hidden' },
    meta: { display: 'flex', flexDirection: 'column', gap: 3, marginBottom: 12 },
    metaRow: { fontSize: 11, color: '#9CA3AF', display: 'flex', alignItems: 'center', gap: 4 },
    footer: { display: 'flex', flexDirection: 'column', gap: 10, borderTop: '1px solid #F1F1EF', paddingTop: 12 },
    priceRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    price: { fontSize: 15, fontWeight: 700, color: '#0D1B2A' },
    qtyRow: { display: 'flex', alignItems: 'center', gap: 8 },
    qtyBtn: { width: 28, height: 28, border: '1px solid #E2DECE', background: '#fff', borderRadius: 6, cursor: 'pointer', fontSize: 15, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    qtyInput: { width: 48, textAlign: 'center', fontSize: 13, fontWeight: 600, border: '1px solid #E2DECE', borderRadius: 6, padding: '5px 4px', outline: 'none' },
    addBtn: (isAdded) => ({ background: isAdded ? '#065F46' : '#0D1B2A', color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer', transition: 'background 0.2s', flex: 1 }),
  };

  if (loading) return <div style={{...s.page, textAlign:'center', paddingTop:120}}>Завантаження...</div>;
  if (error)   return <div style={{...s.page, textAlign:'center', paddingTop:120, color:'red'}}>Помилка: {error}</div>;

  return (
    <div style={s.page}>
      <div style={s.header}>
        <h1 style={s.title}>Каталог товарів</h1>
        <input style={s.search} placeholder="Пошук за назвою, брендом або штрихкодом..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div style={s.filters}>
        {categories.map(cat => (
          <button key={cat.value} style={s.filterBtn(category === cat.value)} onClick={() => setCategory(cat.value)}>
            {cat.label}
          </button>
        ))}
      </div>

      <div style={{marginBottom: 16, fontSize: 14, color: '#6B7280'}}>
        Знайдено товарів: {filtered.length}
      </div>

      <div style={s.grid}>
        {filtered.map(product => (
          <div key={product.id} style={s.card}>
            <div style={s.img}>
              {product.image_url ? (
                <img src={product.image_url} alt={product.name} style={{width:'100%', height:'100%', objectFit:'cover'}} />
              ) : '📦'}
            </div>
            <div style={s.body}>
              <div style={s.brand}>{product.brand}</div>
              <div style={s.name}>{product.name}</div>
              <div style={s.meta}>
                {product.qty_per_box && <div style={s.metaRow}>📦 {product.qty_per_box}</div>}
                {product.supplier_code && <div style={s.metaRow}>🔢 Код: {product.supplier_code}</div>}
                {product.barcode && <div style={s.metaRow}>|||  {product.barcode}</div>}
              </div>
              <div style={s.footer}>
                <div style={s.priceRow}>
                  <div style={s.price}>{Number(product.price).toLocaleString()} ₴/шт</div>
                </div>
                {product.quantity_in_stock !== null && product.quantity_in_stock <= 0 ? (
                  <div style={{fontSize:12, color:'#DC2626', fontWeight:600, padding:'8px 0'}}>❌ Немає в наявності</div>
                ) : (
                  <>
                    {product.quantity_in_stock !== null && (
                      <div style={{fontSize:11, color:'#6B7280', marginBottom:2}}>В наявності: {product.quantity_in_stock} шт</div>
                    )}
                    <div style={s.qtyRow}>
                      <button style={s.qtyBtn} onClick={() => setQty(product.id, getQty(product.id) - 1, product.quantity_in_stock)}>−</button>
                      <input
                        style={s.qtyInput}
                        type="number"
                        min="1"
                        max={product.quantity_in_stock ?? undefined}
                        value={getQty(product.id)}
                        onChange={e => setQty(product.id, e.target.value, product.quantity_in_stock)}
                      />
                      <button style={s.qtyBtn} onClick={() => setQty(product.id, getQty(product.id) + 1, product.quantity_in_stock)}>+</button>
                      <button style={s.addBtn(added[product.id])} onClick={() => handleAdd(product)}>
                        {added[product.id] ? '✓ Додано' : '+ Кошик'}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CatalogPage;
